import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_HOST,
});

export const getGraficosUrl = async (id) => {
  try {
    const response = await api.get(`graf/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao solicitar URL:', error);
    throw error;
  }
};
